/* eslint-disable */
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import FTEStatusTable from "./FTEStatusTable/FTEStatusTable";
import "./FTEWiseChart.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const FTEWiseChart = ({ data, tbaleData }) => {
  const chartData = {
    labels: [
      // "Projection", "Transition in Progess", "Discussion in Progress", "Yet to start"
      "Projection",
      "Transition in Progess",
      "Discussion in Progress",
      "Yet to Start",
      "On Hold",
      "Dropped",
      "Go Live Stabilization,",
      "As Null"
    ],
    datasets: [
      {
        label: "FTE Count",
        backgroundColor: "#b4d2e7",
        // backgroundColor: "#c0ad73", // c0ad73
        data,
        barThickness: 30,
        borderRadius: {
          topLeft: 5,
          topRight: 5,
          bottomLeft: 0,
          bottomRight: 0,
        },
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: "black",
        anchor: "center",
        align: "center",
        font: { weight: "bold", size: 12 },
      },
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            return ` ${context.raw}`;
          },
        },
      },
    },
    scales: {
      y: {
        display: false,
        beginAtZero: true,
      },
      x: {
        ticks: {
          autoSkip: false,
        },
      },
    },
    // scales: {
    //   y: {
    //     beginAtZero: true,
    //     ticks: {
    //       stepSize: 10,
    //       precision: 0,
    //     },
    //   },
    // },
  };

  const fteStatusData = [
    {
      tower: 'P2P',
      workArea: 'IPSW SIN2',
      businessApprover: 'Charmaine Barrett',
      actualFTE: 2,
      actualQtr: 'Q1',
      status: 'Planning',
    },
    {
      tower: 'P2P',
      workArea: 'IOP Change Mgmt. & Release to Order Documentation',
      businessApprover: 'Sebastian Aksari',
      actualFTE: 7,
      actualQtr: 'Q2',
      status: 'Pre Transition',
    },
    {
      tower: 'P2P',
      workArea: 'Part Helpdesk',
      businessApprover: 'Aiden Ford / Melanie Balmer',
      actualFTE: 48,
      actualQtr: 'Q2',
      status: 'Yetto start',
    },
    {
      tower: 'R2R',
      workArea: 'Additional work areas to be explored (JLR)',
      businessApprover: 'Michael Mills/Anne Olexa/Raj Aulak',
      actualFTE: 3,
      actualQtr: 'Q2',
      status: 'Yetto start',
    },
    {
      tower: 'R2R',
      workArea: 'Quality Analytics, Transactions',
      businessApprover: 'Melanie Balmer',
      actualFTE: 6,
      actualQtr: 'Q2',
      status: 'Yetto start',
    },
    {
      tower: 'P2P',
      workArea: 'Scope penetration as per TML Scope',
      businessApprover: 'TBD',
      actualFTE: 20,
      actualQtr: 'Q3',
      status: 'Yetto start',
    },
    {
      tower: 'R2R',
      workArea: 'Additional work areas to be explored (JLR)',
      businessApprover: 'Michael Mills/Anne Olexa/Raj Aulak',
      actualFTE: 4,
      actualQtr: 'Q3',
      status: 'Yetto start',
    },
    {
      tower: 'R2R',
      workArea: 'Stat COE of Multiple JLR Locations',
      businessApprover: 'Olie Tower',
      actualFTE: 6,
      actualQtr: 'Q3',
      status: 'Yetto start',
    },
  ];


  return (
    <div className="trans-bar-chart card p-3">
      <div className="phase-chart-header">
        <span className="title">Phase wise FTE Count</span>
      </div>
      <div className="chart-area">
        <Bar data={chartData} options={options} />
      </div>
      <div className="table-area">
        {/* <FTEStatusTable data={fteStatusData} /> */}
        <FTEStatusTable data={tbaleData} />
      </div>
    </div>
  );
};

export default FTEWiseChart;
